export default __webpack_public_path__ + "4267f5a421fc36e510a4870e934beec4.png";